// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"OptInForm_subtitle__1o9vl"};